import { Navigate, useLocation } from "react-router-dom"
import { useAccount } from "../../hooks/useAccount"
import PrivateRoute from "./PrivateRoute"
import { AuthStatus, useAuth } from "../../hooks/useAuth"

const PractitionerPrivateRoute = (props: {
  children: React.ReactNode
}): React.ReactElement => {
  const { children } = props
  const { account } = useAccount()
  const { status } = useAuth()
  const location = useLocation()

  return status === AuthStatus.Authenticated &&
    account?.role === "practitioner" ? (
    <PrivateRoute>{children}</PrivateRoute>
  ) : (
    <Navigate
      replace={true}
      to="/login"
      state={{ from: `${location.pathname}${location.search}` }}
    />
  )
}

export default PractitionerPrivateRoute
